export const SHORTENER_LENGTH = 21; // default stringLength for shortener pipe
export const HEADER_HEIGHT = 62;
export const THREAD_INNER_HEADER_HEIGHT = 58;
export const THREAD_INNER_HEADER_HEIGHT_MOBILE = 80;
